<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Daily Sales & Collection") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
              >
                {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="
                getDailySalesCollecition((isExcel = 'N' || isPdf == 'N'))
              "
            >
              {{ $t("fetch") }}
            </button>
          </div>

          <div
            v-if="Object.keys(dailyCollection).length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              style="cursor: pointer"
              target="_blank"
              @click="getDailySalesCollecition('N', 'Y')"
              title="Download as Pdf"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              style="cursor: pointer"
              target="_blank"
              @click="getDailySalesCollecition('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div class="section-title mb-3">Summary Performance</div>
      <!-- Sales Collection -->
      <table class="swc-report-table mb-3" border="1">
        <thead class="bg-lightgrey font-weight-bold">
          <th>Daily Sales</th>
          <!-- <th>Admissions</th> -->
          <th>Total(Incl. VAT)</th>
        </thead>
        <tbody>
          <tr>
            <td class="text-left">BoxOffice Show Wise Collection</td>
            <!-- <td class="text-right">{{ boxOfficeShowWise[0].admits || 0 }}</td> -->
            <td class="text-right">
              {{ currFormat(boxOfficeShowWise[0].total_amount || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Fnb Sales Today</td>
            <!-- <td class="text-right">{{ fnbTodaySales[0].admits || 0 }}</td> -->
            <td class="text-right">
              {{ currFormat(fnbTodaySales[0].total_amount || 0) }}
            </td>
          </tr>
          <!-- <tr>
            <td class="text-left">E Wallet Refund</td>
            <td class="text-right">{{ ewalletRefund[0].admits || 0 }}</td>
            <td class="text-right">
              {{ currFormat(ewalletRefund[0].refunded_amount || 0) }}
            </td>
          </tr> -->
          <tr>
            <td class="text-left">Booking Fee</td>
            <!-- <td class="text-right">{{ bookingFeeData.admits || 0 }}</td> -->
            <td class="text-right">
              {{ currFormat(bookingFeeData.total || 0) }}
            </td>
          </tr>

           <tr>
            <td class="text-left">Add On Charges</td>
            <!-- <td class="text-right">{{ bookingFeeData.admits || 0 }}</td> -->
            <td class="text-right">
              {{ currFormat(boxOfficeShowWise[0].add_on_charges || 0) }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Sales Collection -->
      <div
        class="section-title mb-3"
        v-if="Object.keys(salesCollection).length > 0"
      >
        Sales Collection
      </div>
      <!-- Sales Collection -->
      <table
        class="swc-report-table"
        border="1"
        v-if="Object.keys(salesCollection).length > 0"
      >
        <thead class="bg-lightgrey font-weight-bold">
          <th>Daily Sales</th>
          <!-- <th>Admissions</th> -->
          <th>Amount</th>
          <th>VAT</th>
          <th>Total(Incl. VAT)</th>
        </thead>
        <tbody v-if="Object.keys(salesCollection).length > 0">
          <template v-for="(salesObj, salesIndex) in salesCollection">
            <tr
              :key="salesIndex"
              :class="
                salesIndex == 'total_amount'
                  ? 'font-weight-bold bg-lightgrey'
                  : ''
              "
            >
              <template v-for="(salesDataObj, salesDataIndex) in salesObj">
                <td
                  :key="salesDataIndex + salesIndex"
                  v-if="salesDataIndex != 'admits'"
                  :class="
                    notNumberHeaders.includes(salesDataIndex)
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  {{
                    notCurrFormatArr.includes(salesDataIndex)
                      ? salesDataObj
                      : currFormat(salesDataObj)
                  }}
                </td>
              </template>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Sales Collection -->

      <!-- Admits Data -->
      <table
        class="swc-report-table"
        border="1"
        v-if="Object.keys(admitsData).length > 0"
      >
        <thead class="bg-lightgrey font-weight-bold">
          <th>Admissions</th>
          <th>Daily</th>
          <th>Prior</th>
          <th>Advance</th>
          <th>Refundless Prior</th>
        </thead>
        <tbody v-if="Object.keys(admitsData).length > 0">
          <tr>
            <td class="text-left">
              {{ admitsData.offlineCollection.row_name }}
            </td>
            <td class="text-right">{{ admitsData.offlineCollection.daily }}</td>
            <td class="text-right">{{ admitsData.offlineCollection.prior }}</td>
            <td class="text-right">
              {{ admitsData.offlineCollection.advance }}
            </td>
            <td class="text-right">
              {{ admitsData.offlineCollection.refundlessPrior }}
            </td>
          </tr>
          <tr>
            <td class="text-left">
              {{ admitsData.onlineCollection.row_name }}
            </td>
            <td class="text-right">{{ admitsData.onlineCollection.daily }}</td>
            <td class="text-right">{{ admitsData.onlineCollection.prior }}</td>
            <td class="text-right">
              {{ admitsData.onlineCollection.advance }}
            </td>
            <td class="text-right">
              {{ admitsData.onlineCollection.refundlessPrior }}
            </td>
          </tr>
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">{{ admitsData.total.row_name }}</td>
            <td class="text-right">{{ admitsData.total.daily }}</td>
            <td class="text-right">{{ admitsData.total.prior }}</td>
            <td class="text-right">{{ admitsData.total.advance }}</td>
            <td class="text-right">{{ admitsData.total.refundlessPrior }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Admits Data -->
      <!-- Daily Collection -->
      <div class="section-title my-3">Daily Collection</div>
      <table class="swc-report-table" border="1">
        <thead class="bg-lightgrey font-weight-bold">
          <th>Daily Sales</th>
          <!-- <th>Admissions</th> -->
          <th>Amount</th>
          <th>VAT</th>
          <th>Total(Incl. VAT)</th>
        </thead>
        <tbody v-if="Object.keys(dailyCollection).length > 0">
          <template
            v-for="(
              dailyCollectionObj, dailyCollectionIndex
            ) in dailyCollection"
          >
            <tr
              :key="dailyCollectionIndex"
              :class="
                dailyCollectionIndex == 'total_amount'
                  ? 'font-weight-bold bg-lightgrey'
                  : ''
              "
            >
              <template
                v-for="(dailyData, dailyDataIndex) in dailyCollectionObj"
              >
                <td
                  :key="dailyDataIndex + dailyCollectionIndex"
                  v-if="dailyDataIndex != 'admits'"
                  :class="
                    notNumberHeaders.includes(dailyDataIndex)
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  {{
                    notCurrFormatArr.includes(dailyDataIndex)
                      ? dailyData
                      : currFormat(dailyData)
                  }}
                </td>
              </template>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Daily Collection -->
      <!-- Prior Collection -->
      <div class="section-title my-3">Prior Collection</div>
      <table class="swc-report-table" border="1">
        <thead class="bg-lightgrey font-weight-bold">
          <th>Previous Sales</th>
          <!-- <th>Admissions</th> -->
          <th>Amount</th>
          <th>VAT</th>
          <th>Total(Incl. VAT)</th>
        </thead>
        <tbody v-if="Object.keys(priorCollection).length > 0">
          <template
            v-for="(
              priorCollectionObj, priorCollectionIndex
            ) in priorCollection"
          >
            <tr
              :key="priorCollectionIndex"
              :class="
                priorCollectionIndex == 'total_amount'
                  ? 'font-weight-bold bg-lightgrey'
                  : ''
              "
            >
              <template
                v-for="(priorData, priorDataIndex) in priorCollectionObj"
              >
                <td
                  :key="priorDataIndex + priorCollectionIndex"
                  v-if="priorDataIndex != 'admits'"
                  :class="
                    notNumberHeaders.includes(priorDataIndex)
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  {{
                    notCurrFormatArr.includes(priorDataIndex)
                      ? priorData
                      : currFormat(priorData)
                  }}
                </td>
              </template>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Prior Collection -->
      <!-- Advance Collection -->
      <div class="section-title my-3">Advance Collection</div>
      <table class="swc-report-table" border="1">
        <thead class="bg-lightgrey font-weight-bold">
          <th>Advance Sales</th>
          <!-- <th>Admissions</th> -->
          <th>Amount</th>
          <th>VAT</th>
          <th>Total(Incl. VAT)</th>
        </thead>
        <tbody v-if="Object.keys(advanceCollection).length > 0">
          <template
            v-for="(
              advanceCollectionObj, advanceCollectionIndex
            ) in advanceCollection"
          >
            <tr
              :key="advanceCollectionIndex"
              :class="
                advanceCollectionIndex == 'total_amount'
                  ? 'font-weight-bold bg-lightgrey'
                  : ''
              "
            >
              <template
                v-for="(advanceData, advanceDataIndex) in advanceCollectionObj"
              >
                <td
                  :key="advanceDataIndex + advanceCollectionIndex"
                  v-if="advanceDataIndex != 'admits'"
                  :class="
                    notNumberHeaders.includes(advanceDataIndex)
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  {{
                    notCurrFormatArr.includes(advanceDataIndex)
                      ? advanceData
                      : currFormat(advanceData)
                  }}
                </td>
              </template>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Advance Collection -->

      <!-- EWallet Refund -->
      <div class="section-title my-3">EWallet Refund</div>
      <table class="swc-report-table" border="1">
        <thead class="bg-lightgrey font-weight-bold">
          <th>Refund Sales</th>
          <!-- <th>Admissions</th> -->
          <th>Refund Total(Incl. VAT)</th>
        </thead>
        <tbody v-if="ewalletRefund.length">
          <tr>
            <td class="text-left">E Wallet Refund</td>
            <!-- <td class="text-right">{{ ewalletRefund[0].admits || 0 }}</td> -->
            <td class="text-right">
              {{ currFormat(ewalletRefund[0].refunded_amount || 0) }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- EWallet Refund -->

      <!-- Advance Collection -->
      <div class="section-title my-3">Refund Less Prior</div>
      <table class="swc-report-table" border="1">
        <thead class="bg-lightgrey font-weight-bold">
          <th>Refund Sales</th>
          <!-- <th>Admissions</th> -->
          <th>Amount</th>
          <th>VAT</th>
          <th>Total(Incl. VAT)</th>
        </thead>
        <tbody v-if="Object.keys(RefundLessPrior).length > 0">
          <template
            v-for="(
              advanceCollectionObj, advanceCollectionIndex
            ) in RefundLessPrior"
          >
            <tr
              :key="advanceCollectionIndex"
              :class="
                advanceCollectionIndex == 'total_amount'
                  ? 'font-weight-bold bg-lightgrey'
                  : ''
              "
            >
              <template
                v-for="(advanceData, advanceDataIndex) in advanceCollectionObj"
              >
                <td
                  :key="advanceDataIndex + advanceCollectionIndex"
                  v-if="advanceDataIndex != 'admits'"
                  :class="
                    notNumberHeaders.includes(advanceDataIndex)
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  {{
                    notCurrFormatArr.includes(advanceDataIndex)
                      ? advanceData
                      : currFormat(advanceData)
                  }}
                </td>
              </template>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Advance Collection -->

      <!-- Summary table -->
      <div class="section-title my-3">Summary</div>

      <table class="swc-report-table mb-3" border="1">
        <tbody v-if="Object.keys(summaryTable).length > 0">
          <tr>
            <td class="text-left">Box Office</td>
            <td class="text-right">
              {{ currFormat(summaryTable.boxOfficeTotalCollection || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Concessions</td>
            <td class="text-right">
              {{ currFormat(summaryTable.FnbTotalCollection || 0) }}
            </td>
          </tr>

          <tr>
            <td class="text-left">3D Glass</td>
            <td class="text-right">
              {{ currFormat(summaryTable.TotalFor3D || 0) }}
            </td>
          </tr>

            <tr>
            <td class="text-left">Add On Charges</td>
            <td class="text-right">{{ currFormat(summaryTable.addOnCharge || 0) }}</td>
          </tr>

          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">Total Revenue</td>
            <td class="text-right">
              {{ currFormat(summaryTable.GrandTotalForBoxOfficeFnb3D || 0) }}
            </td>
          </tr>

          <!-- ----------- -->
          <tr>
            <td class="text-left">Advance Collection</td>
            <td class="text-right">
              {{ currFormat(summaryTable.totalForAdvanceSales || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Prior Collection</td>
            <td class="text-right">
              {{ currFormat(summaryTable.totalForPriorSales || 0) }}
            </td>
          </tr>

          <tr>
            <td class="text-left">E-Wallet Refund</td>
            <td class="text-right">
              {{ currFormat(summaryTable.totalForewalletRefundData || 0) }}
            </td>
          </tr>
          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">Net Sales</td>
            <td class="text-right">
              {{ currFormat(summaryTable.GrandTotalForNetSales || 0) }}
            </td>
          </tr>
          <!-- ----------------- -->

          <tr
            class="font-weight-bold"
            style="background-color: rgb(232, 232, 232)"
          >
            <td class="text-left" colspan="2">Daily Collection Details</td>
          </tr>
          <tr>
            <td class="text-left">Cash Collection(BOX and Concession)</td>
            <td class="text-right">
              {{ currFormat(summaryTable.cashCollectionBOXAndConcession || 0) }}
            </td>
          </tr>

          <tr>
            <td class="text-left">
              Credit Card Collection(BOX and Concession)
            </td>
            <td class="text-right">
              {{
                currFormat(
                  summaryTable.creditCardCollectionBoxAndConcession || 0
                )
              }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Online Booking Collection</td>
            <td class="text-right">
              {{ currFormat(summaryTable.onlineBookingCollection || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Online FNB Collection</td>
            <td class="text-right">
              {{ currFormat(summaryTable.OnlineFnbCollection || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Talabat</td>
            <td class="text-right">
              {{ currFormat(summaryTable.talabat || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Noon</td>
            <td class="text-right">{{ currFormat(summaryTable.noon || 0) }}</td>
          </tr>
          <tr>
            <td class="text-left">Careem</td>
            <td class="text-right">
              {{ currFormat(summaryTable.careem || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">E Wallet Redemption</td>
            <td class="text-right">
              {{ currFormat(summaryTable.eWalletCollection || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Prepaid voucher Collection</td>
            <td class="text-right">
              {{ currFormat(summaryTable.prepaidVoucherCollection || 0) }}
            </td>
          </tr>
          <tr>
            <td class="text-left">Other Collection</td>
            <td class="text-right">
              {{ currFormat(summaryTable.otherCollection || 0) }}
            </td>
          </tr>

          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">Total Daily Collection</td>
            <td class="text-right">
              {{ currFormat(summaryTable.totalForDailyCollectionDetails || 0) }}
            </td>
          </tr>

          <tr class="bg-lightgrey font-weight-bold">
            <td class="text-left">Difference</td>
            <td class="text-right">
              {{
                currFormat(
                  summaryTable.GrandTotalForNetSales -
                    summaryTable.totalForDailyCollectionDetails
                )
              }}
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Summary table -->
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import NewReportService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { CLIENT_NAME } from "@/helper/Role";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      salesCollection: {},
      dailyCollection: {},
      priorCollection: {},
      advanceCollection: {},
      RefundLessPrior: {},
      admitsData: {},
      notNumberHeaders: ["row_name"],
      notCurrFormatArr: ["admits"],
      excelFilePath: "",
      bookingFeeData: {},
      grandTotal: {},
      summaryTable: {},
      boxOfficeShowWise: [
        {
          admits: 0,
          total_amount: 0,
        },
      ],
      fnbTodaySales: [
        {
          admits: 0,
          total_amount: 0,
        },
      ],
      ewalletRefund: [
        {
          admits: 0,
          total_amount: 0,
        },
      ],
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    const { cinema_id } = this.secureStore.get("USINFO");
    this.getCinemaList(cinema_id);
    if (CLIENT_NAME.PLAYCINEMA == this.CLIENT_SETUP_NAME) {
      this.$router.replace(
        "/reports/daily-sales-reports/daily-sales-and-collection-report-play"
      );
    }
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    moment,
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function (cinema_id) {
      MasterService.GetCinemas({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getDailySalesCollecition(isExcel, isPdf) {
      if (isExcel == "N" || isPdf == "N") {
        this.salesCollection = {};
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.fromDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
      };
      NewReportService.GetDailySalesCollectionV2(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.salesCollection = { ...data.salesDetails };
            this.dailyCollection = { ...data.dailyCollection };
            this.priorCollection = { ...data.priorCollection };
            this.advanceCollection = { ...data.advanceCollection };
            this.RefundLessPrior = { ...data.RefundLessPrior };
            this.boxOfficeShowWise = [...data.showWiseCollection];
            this.fnbTodaySales = [...data.fnb_transactions_created];
            this.ewalletRefund = [...data.ewalletRefundData];
            this.bookingFeeData = { ...data.bookingFeeSalesObj };
            this.summaryTable = { ...data.summaryTable };
            this.admitsData = { ...data.admitsData };
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dailySalesAndCollectionStar.vue